import { z } from 'zod';

export const UocTransferOutSchema = z.object({
  to_username: z.string().min(1).max(32),
  amount_uoc: z.string(),
  memo: z.string().max(500).optional(),
  transaction_password: z.string().min(1).max(128),
  security_answer: z.string().min(1).max(256),
});

export type UocTransferOutRequest = z.infer<typeof UocTransferOutSchema>;

export const ApDonateUoSchema = z.object({
  fp_amount: z.string(),
  transaction_password: z.string().min(1).max(128),
  security_answer: z.string().min(1).max(256),
  memo: z.string().max(500).optional(),
});

export type ApDonateUoRequest = z.infer<typeof ApDonateUoSchema>;
